// @flow

// Types
import type {
  AuthState,
} from '../types'

// Action Types
import {
  LOGIN,
  RECEIVE_TOKEN,
  IS_BOOTING,
  REMOVE_CREDENTIALS,
} from './constants'

import { ActionTypes } from 'redux/src/createStore'

export function login (state: AuthState): AuthState {
  const isAuthenticating: boolean = state.isAuthenticating

  if (!isAuthenticating) {
    return {
      ...state,
      isAuthenticating: true,
    }
  }

  return state
}

export function receiveToken
(state: AuthState, { user, token }: { user: string, token: string }): AuthState {
  return {
    ...state,
    user,
    token,
    isAuthenticated: true,
    isAuthenticating: false,
  }
}

export function isBooting (state: AuthState): AuthState {
  return {
    ...state,
    isBooting: false,
  }
}

export function removeCredentials (state: AuthState): AuthState {
  return {
    ...state,
    isAuthenticated: false,
    token: null,
  }
}

export default {
  [LOGIN]: login,
  [RECEIVE_TOKEN]: receiveToken,
  [REMOVE_CREDENTIALS]: removeCredentials,
  [IS_BOOTING]: isBooting,
  [ActionTypes.INIT]: (state: Object): Object => ({...state, isBooting: true}),
}
